module.exports = __webpack_public_path__ + "static/img/four.e85428d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/four.jpeg
// module id = BCfI
// module chunks = 0